// extracted by mini-css-extract-plugin
export default {"cart-counter":"CartCounter_cart-counter__-dbb2"};